export default "__VITE_ASSET__DPryt$EO__"